@if (isActive()) {
    @let actualIconType = iconType();
    <button
        class="button-icon-renderer se-button-no-ripple"
        mat-icon-button
        [ariaLabel]="tooltip() | translate"
        [matTooltip]="tooltip() | translate"
        matTooltipShowDelay="500"
        (click)="onClick($event)"
    >
        @if (actualIconType === EconTypes.SeSvg) {
            <mat-icon [svgIcon]="icon()"></mat-icon>
        } @else if (actualIconType === EconTypes.AngularMaterial) {
            <mat-icon TooltipShowDelay="500">{{ icon() }}</mat-icon>
        } @else if (actualIconType === EconTypes.SeFont) {
            <mat-icon fontSet="estensa-icons">{{ icon() }}</mat-icon>
        }
    </button>
}
